import { useEffect, useState } from 'react'
import './popup.css'

export function Popup({title, children}) {

    return (<>
        <div className='center-blur-bg'>
            <div className="popup">
                <h1 className='popup-heading'> {title} </h1> 
                <div className="popup_internal">
                    {children}
                </div>
            </div>
        </div>
    </>)
}